<template>
  <span class="renderer" style="line-height: 1">   
    <MonitoringStatus
      :rmStatus="rmStatus" 
      :rmprocedures="!!rmprocedures ? rmprocedures : null" 
      isCompact 
    />
  </span>
</template>

<script>
import MonitoringStatus from '@/components/devices/MonitoringStatus.vue';

export default {
  name: "monitoringRenderer",
  props: ["object"],
  data() {
    return {
      rmStatus: this.object?.rmStatus,
      rmprocedures: this.object?.rmprocedures,
    };
  },
  components: {
    MonitoringStatus,
  },
};
</script>
